import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsent.vue?vue&type=style&index=0&id=6c50ee19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c50ee19"]])

export default __exports__